import { createGlobalStyle } from 'styled-components';
import { Fonts } from './fonts';
import { Locomotive } from './locomotive';

const GlobalStyles = createGlobalStyle`
    ${Fonts};
    ${Locomotive};

    :root{
        --burlywood: #f6c9a0;
        --grey: #866c55;
        --black: #141414;
        --white: #f4f4f6;
        --dullWhite: #b1b1b1;
        --silver: #d4d4d8;
        --platinum: #e6e6e9;
        --taupe: #b5b5ba;
        --dim: #66666e;
        --battleGray: #858585;
        --french: #b5b5ba;
        --onyx: #5b5b5b;
        --jet: #292929;
        --jetLight: #333333;
        --jetGray: #6d6d74;
        --deepBlack: #0a0a0a;
        --richBlack: #2e2e2e;
        --eerieDark: #131313;
        --eerieBlack: #1f1f1f;
    }

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    h1, h2, h3, h4, h5, p, a{
        color: var(--dullWhite);
    }

    h1, h2, h3, h4, a{
        font-family: Monument;
    }

    li{
        list-style: none;
    }

    img{
        width: 100%;
        display: block;
    }

    html{
        overflow: hidden;
        min-height: -webkit-fill-available;
    }


    body{
        background-color: var(--deepBlack);
        cursor: none;
        isolation: isolate;
        min-height: 100vh;
        min-height: -webkit-fill-available;
    }

    p{
        font-family: Grotesk;
        font-weight: 400;
        font-size: calc(var(--VW)*1.5);
        word-spacing: calc(var(--VW) *0.2);
        line-height: 120%;
        overflow-wrap: break-word;
        word-wrap: break-word;
        -webkit-hyphens: auto;
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        hyphens: auto;
        @media (hover: none) and (pointer: coarse){
            font-size: calc(var(--VW)*3);
            word-spacing: calc(var(--VW) *0.5);
        }
        @media (hover: none) and (pointer: coarse) and (max-width: 500px), (max-width: 500px){
            font-size: calc(var(--VW)*5);
            word-spacing: calc(var(--VW) *0.5);
        }
    }

    a{
        color: var(--dullWhite);
        text-decoration: none;
        font-weight: 800;
        text-transform: uppercase;
        mix-blend-mode: difference;
        outline: none;
        &:hover{
            -webkit-text-fill-color: var(--eerieDark);
            -webkit-text-stroke: calc(var(--VW)*0.14) var(--dullWhite);
            cursor: none;
        }
    }

`;

export { GlobalStyles };
